"use client";

import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue } from "@/Components/website/ui/select";
import UserIcon from "@/Components/website/common/Icons/UserIcon";
import EmailIcon from "@/Components/website/common/Icons/EmailIcon";
import axios from "axios";
const ContactUsForm = () => {
  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: {
      errors
    }
  } = useForm();
  const {
    name,
    email,
    message
  } = watch();
  const isFormValid = name && email && message;
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const submitContact = async data => {
    try {
      setIsSubmitting(true);
      axios(`${process.env.NEXT_PUBLIC_BASE_URL}/contact-us/create`, {
        method: "POST",
        data: data
      }).then(res => {
        setIsSubmitting(false);
        setSuccess(true);
        reset();
      }).catch(err => {
        setIsSubmitting(false);
        setSuccess(false);
        setError(err.response?.data?.message || err.message || "Internal server error");
      });
    } catch (error_0) {
      setIsSubmitting(false);
      setSuccess(false);
      setError(error_0.message || "Internal server error");
      console.error("Error:", error_0);
    }
  };
  return <>
      {error && <div id="error-form" className="text-sm mt-3 w-full lg:w-[75%] bg-red-500/10 text-red-600 px-3 py-2 rounded-lg">
        {error}
      </div>}
      {success && <div id="success-form" className="text-sm mt-3 w-full lg:w-[75%] bg-green-500/10 text-green-600 px-3 py-2 rounded-lg">
        {"Contact request created, Our team will connect with you shortly!"}
      </div>}
      <form onSubmit={handleSubmit(submitContact)} className="w-full lg:w-[55%] space-y-5">
        <div className="space-y-2">
          <label className="text-sm text-smokeGrey font-medium">Your name</label>
          <div className="flex items-center gap-2 border px-2 rounded-lg">
            <UserIcon />
            <input type="text" placeholder="Enter your name" className="bg-transparent py-2.5 border-none outline-none w-full" {...register("name", {
            required: "Name is required",
            pattern: {
              value: /^[A-Za-z\s]+$/,
              message: "Name must contain only alphabets"
            }
          })} />
          </div>
          {errors.name && <p className="text-red-600 text-sm font-medium">{errors.name.message}</p>}
        </div>

        <div className="space-y-2">
          <label className="text-sm text-smokeGrey font-medium">Your email</label>
          <div className="flex items-center gap-2 border px-2 rounded-lg">
            <EmailIcon />
            <input type="email" placeholder="Enter your email" className="bg-transparent py-2.5 border-none outline-none w-full" {...register("email", {
            required: "Email is required",
            pattern: {
              value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
              message: "Enter a valid email address"
            }
          })} />
          </div>
          {errors.email && <p className="text-red-600 text-sm font-medium">{errors.email.message}</p>}
        </div>
        {/* <div className="space-y-2">
         <div className="hidden space-y-2">
         search_module_fix
         <label className="text-sm text-smokeGrey font-medium">
          Query category
         </label>
         <Select
          onValueChange={(value) => handleInputChange("category", value)}
         >
          <SelectTrigger className="w-full">
            <SelectValue placeholder="Select a category" />
          </SelectTrigger>
          <SelectContent>
            <SelectGroup>
              <SelectLabel>- Select category</SelectLabel>
              <SelectItem value="Humira">Humira</SelectItem>
              <SelectItem value="Humalog">Humalog</SelectItem>
              <SelectItem value="Bunavail">Bunavail</SelectItem>
              <SelectItem value="Dupixent">Dupixent</SelectItem>
              <SelectItem value="Zubsolv">Zubsolv</SelectItem>
            </SelectGroup>
          </SelectContent>
         </Select>
         </div> */}
        <div className="space-y-2">
          <label className="text-sm text-smokeGrey font-medium">Your message</label>
          <textarea cols="45" rows="8" placeholder="Enter your message" className="w-full rounded-lg p-2 resize-none border border-gray-300 outline-none" {...register("message", {
          required: "Message is required"
        })}></textarea>
          {errors.message && <p className="text-red-600 text-sm font-medium">{errors.message.message}</p>}
        </div>

        <button type="submit" className={`text-white text-[16px] font-medium p-2 w-full rounded-lg py-3 ${isFormValid && !isSubmitting ? "bg-primary-primaryBlueBg" : "bg-gray-400"}`} disabled={!isFormValid || isSubmitting}>
          {isSubmitting ? "Loading..." : "Send Message"}
        </button>
      </form>
    </>;
};
export default ContactUsForm;